import React, { useEffect, useState, useRef } from "react";
import AddIcon from '@mui/icons-material/Add';
// import { Modal, Box, TextField, InputLabel } from '@mui/material';
import Card from '@mui/material/Card';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CompanySVGComponent from "../../Components/Common/SVGComponents/CompanySVGComponent";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
// import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from "@mui/icons-material/Save";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '../../Components/Common/ClassicEditor';
import dayjs from "dayjs";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useDispatch, useSelector } from "react-redux";
import "./../../Bookclosure/Styles/Bookclosure.css"
import {
    removeAdjustmentFromTable,
    setAdjustments,
    setIsAddToTackModalOpen,
    setIsEditLedgerModal,
    setNewAdjustmentToTable,
    setOnchangeAdj,
    setTaskComments,
} from "../../redux/actions/BookClosure/actionBookClosure";
import { customStyles } from "./AddTaskModal";
import swal from "sweetalert";
import { toast } from "react-toastify";

import "../../myfin_v2/css/module.css"

import commoncss from "../../myfin_v2/css/common.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import tablecss from "../../myfin_v2/css/table.module.css";
import bookclosuretaskscss from "../../myfin_v2/css/bookclosuretasks.module.css";
import commentscss from "../../myfin_v2/css/comments.module.css";
import Modal from "../../myfin_v2/elements/Modal";
import ToggleButton from "../../myfin_v2/elements/ToggleButton";
import { Button, TableButton, IconButton } from "../../myfin_v2/elements/Button";
import Dropdown from "../../myfin_v2/elements/Dropdown";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as LeftIcon } from "../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as CalenderIcon } from "../../myfin_v2/assets/icons/calender.svg";
import { ReactComponent as RoundedCheckIcon } from "../../myfin_v2/assets/icons/rounded_check.svg";
import { ReactComponent as AttachmentIcon } from "../../myfin_v2/assets/icons/attachment.svg";
import { ReactComponent as PrimaryPlusIcon } from "../../myfin_v2/assets/icons/primary_plus.svg";
import { ReactComponent as DeleteRedIcon } from "../../myfin_v2/assets/icons/delete_red.svg";
import { ReactComponent as ReplyIcon } from "../../myfin_v2/assets/icons/reply.svg";
import { ReactComponent as MenuDotIcon } from "../../myfin_v2/assets/icons/menu_dot.svg";
import { ReactComponent as EditIcon } from "../../myfin_v2/assets/icons/edit.svg";
import { ReqFieldLabel } from "../../myfin_v2/components/mis";
import modules from "../../myfin_v2/data/modules.json"
import BookClosureModuleTasks from '../Components/BookClosureModuleTasks';
import BookClosureConnectedTasks from '../Components/BookClosureConnectedTasks';
import AddCommentModal from "../../myfin_v2/components/bookclosure/AddCommentModal";
import User3 from "../../myfin_v2/assets/imgs/user3.jpg";
import {
    AddAdjustmentToTask, addCommentToTask, getOneTask, updateAdjustmentToTask, postReplyApiHandler, deleteCommentApiHandler,
    updateCommentApiHandler, getRegistersDataApiHandler, getAllLeaseDataApiHandler, updateTemplateTaskLedgersApiHandler,
    updateConnectedTaskReviewApiHandler, reopenBookClosureTaskApiHandler
} from "../Services/ApiHandler";
import { formatAmount } from "../../utils/formatAmount";
import bookclosuretablecss from "../../myfin_v2/css/bookclosuretable.module.css";


export const unresolvedCustomStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#E5A503',
        // borderColor: '#c2e6d1',
        color: '#ffffff',
        boxShadow: 'none',
        borderWidth: '1px',
        borderRadius: '0.5rem',
        '&:hover': {
            // borderColor: '#b3c0bd',
        },
        minHeight: '38px',
        height: '38px'
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '2px 8px',
        paddingTop: '1px'
    }),
    input: (provided) => ({
        ...provided,
        color: '#ffffff',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#ffffff',
        fontSize: "14px",
        transform: 'translateY(-65%) !important'

    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#ffffff',
        fontSize: "14px",
        fontWeight: 500,
        textTransform: "uppercase",
        letterSpacing: "1px",
        transform: 'translateY(-65%) !important'
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#e0f5e9', // softer variant
        borderRadius: '0.25rem',
        border: '1px solid #c2e6d1',
        width: 'fit-content'
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#ffffff',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            backgroundColor: '#c2e6d1',
            color: '#4f665f',
        },
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        color: '#ffffff',
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: '#ffffff',
        ':hover': {
            color: '#ffffff',
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#ffffff',
        ':hover': {
            color: '#ffffff',
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#f4faf5',
        border: '1px solid #ffffff',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
        borderRadius: '0.5rem',
        zIndex: 10,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: 0,
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#c2e6d1'
            : state.isFocused
                ? '#e9f7ef'
                : 'transparent',
        color: '#4f665f',
        padding: '10px 12px',
        cursor: 'pointer',
        fontSize: "14px"
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        padding: '8px 12px',
    }),
};


export const closedCustomStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#205a46',
        // borderColor: '#c2e6d1',
        color: '#ffffff',
        boxShadow: 'none',
        borderWidth: '1px',
        borderRadius: '0.5rem',
        '&:hover': {
            // borderColor: '#b3c0bd',
        },
        minHeight: '38px',
        height: '38px'
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '2px 8px',
        paddingTop: '1px'
    }),
    input: (provided) => ({
        ...provided,
        color: '#ffffff',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#ffffff',
        fontSize: "14px",
        transform: 'translateY(-65%) !important'

    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#ffffff',
        fontSize: "14px",
        fontWeight: 500,
        textTransform: "uppercase",
        letterSpacing: "1px",
        transform: 'translateY(-65%) !important'
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#e0f5e9', // softer variant
        borderRadius: '0.25rem',
        border: '1px solid #c2e6d1',
        width: 'fit-content'
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#ffffff',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            backgroundColor: '#c2e6d1',
            color: '#4f665f',
        },
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        color: '#ffffff',
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: '#ffffff',
        ':hover': {
            color: '#ffffff',
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#ffffff',
        ':hover': {
            color: '#ffffff',
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#f4faf5',
        border: '1px solid #ffffff',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
        borderRadius: '0.5rem',
        zIndex: 10,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: 0,
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#c2e6d1'
            : state.isFocused
                ? '#e9f7ef'
                : 'transparent',
        color: '#4f665f',
        padding: '10px 12px',
        cursor: 'pointer',
        fontSize: "14px"
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        padding: '8px 12px',
    }),
};

export const overdueCustomStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#f00808',
        // borderColor: '#c2e6d1',
        color: '#ffffff',
        boxShadow: 'none',
        borderWidth: '1px',
        borderRadius: '0.5rem',
        '&:hover': {
            // borderColor: '#b3c0bd',
        },
        minHeight: '38px',
        height: '38px'
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '2px 8px',
        paddingTop: '1px'
    }),
    input: (provided) => ({
        ...provided,
        color: '#ffffff',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#ffffff',
        fontSize: "14px",
        transform: 'translateY(-65%) !important'

    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#ffffff',
        fontSize: "14px",
        fontWeight: 500,
        textTransform: "uppercase",
        letterSpacing: "1px",
        transform: 'translateY(-65%) !important'
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#e0f5e9', // softer variant
        borderRadius: '0.25rem',
        border: '1px solid #c2e6d1',
        width: 'fit-content'
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#ffffff',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            backgroundColor: '#c2e6d1',
            color: '#4f665f',
        },
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        color: '#ffffff',
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: '#ffffff',
        ':hover': {
            color: '#ffffff',
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#ffffff',
        ':hover': {
            color: '#ffffff',
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#f4faf5',
        border: '1px solid #ffffff',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
        borderRadius: '0.5rem',
        zIndex: 10,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: 0,
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#c2e6d1'
            : state.isFocused
                ? '#e9f7ef'
                : 'transparent',
        color: '#4f665f',
        padding: '10px 12px',
        cursor: 'pointer',
        fontSize: "14px"
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        padding: '8px 12px',
    }),
};

const LeaseModal = ({
    isLeaseMonthlyDepFinModal,
    handleTaskModalClose,
    addTaskForm,
    setAddTaskForm,
    UpdateTask,
    SaveTask,
    userData,
    assetsTags,
    LedgersData,
    assetReconcillation,
    leaseLiabilityReconcillation,
    handleDragStart,
    handleDrop,
    addNewAsset,
    handleAssetChange,
    HandleSave,
    HandleDelete,
    HandleUpdate,
    tagLedgers,
    connectedTasks,
    ViewTaskMore,
    addedColumns,
    taskDetails,
    checkReviewed,
    prevTaskId
}) => {
    const animatedComponents = makeAnimated();
    const dispatch = useDispatch();
    const {
        assignOptions,
        approveOptions,
        comments, adjustments, ledgers, bookClosureTasks
    } = useSelector((state) => state.BookClosureReducer);


    const commentStatuses = [{ "label": "Unresolved", "value": "unresolved" }, { "label": "Resolved", "value": "resolved" },
    { "label": "Closed", "value": "closed" }, { "label": "OverDue", "value": "overdue" }]
    const [taskColumnList, setTaskColumnList] = useState([])
    const [addCommentModal, setAddCommentModal] = useState(false);
    const [commentsList, setCommentsList] = useState([]);
    const [showCommentThread, setShowCommentThread] = useState(false);
    const [selComment, setCommentText] = useState([]);
    const [commentReply, setCommentReply] = useState("");
    const [disableActions, setDisableAction] = useState(false);
    const [reOpenTask, setReOpenTask] = useState(false);

    const [linkedRegisters, setLinkedRegisters] = useState([]);
    const [registersList, setRegistersList] = useState([]);
    const [showRegistersList, setShowRegistersList] = useState(false);
    const [depreciationRegisterAmount, setDepreciationRegisterAmount] = useState('');
    const [depreciationLedgerAmount, setDepreciationLedgerAmount] = useState('');
    const [depreciationDifferenceAmount, setDepreciationDifferenceAmount] = useState('');
    const [financeRegisterAmount, setFinanceRegisterAmount] = useState('');
    const [financeLedgerAmount, setFinanceLedgerAmount] = useState('');
    const [financeDifferenceAmount, setFinanceDifferenceAmount] = useState('');


    const [linkedDepLedgers, setLinkedDepLedgers] = useState([]);
    const [depLedgersList, setDepLedgersList] = useState([]);
    const [showDepLedgersList, setShowDepLedgersList] = useState(false);

    const [linkedFinLedgers, setLinkedFinLedgers] = useState([]);
    const [finLedgersList, setFinLedgersList] = useState([]);
    const [showFinLedgersList, setShowFinLedgersList] = useState(false);

    const [totalAccumulatedDepreciationAmount, setTotalAccumulatedDepreciationAmount] = useState('');

    useEffect(() => {
        if ((userData?.responsibilities === "approver") || (checkReviewed !== "N")) {
            setDisableAction(true);
        } else {
            setDisableAction(false);
        }
    }, [userData, checkReviewed])

    useEffect(() => {

        setLinkedRegisters(() => {
            const result = [];
            if (taskDetails) {
                for (let i = 0; i < taskDetails.linkedRegisters.length; i++) {
                    if (taskDetails.linkedRegisters[i].checked === true) {
                        result.push(taskDetails.linkedRegisters[i]);
                    }
                }
            }
            return result;
        });

        setRegistersList(() => {
            const result = [];
            if (taskDetails) {
                for (let i = 0; i < taskDetails.linkedRegisters.length; i++) {
                    result.push(taskDetails.linkedRegisters[i]);
                }
            }
            return result;
        });
        console.log("taskDetails.depreciationLedgers", taskDetails.depreciationLedgers);

        setLinkedDepLedgers(() => {
            const result = [];
            if (taskDetails) {
                for (let i = 0; i < taskDetails.depreciationLedgers.length; i++) {
                    if (taskDetails.depreciationLedgers[i].checked === true) {
                        result.push(taskDetails.depreciationLedgers[i]);
                    }
                }
            }
            return result;
        });

        setDepLedgersList(() => {
            const result = [];
            if (taskDetails) {
                for (let i = 0; i < taskDetails.depreciationLedgers.length; i++) {
                    result.push(taskDetails.depreciationLedgers[i]);
                }
            }
            return result;
        });

        setLinkedFinLedgers(() => {
            const result = [];
            if (taskDetails) {
                for (let i = 0; i < taskDetails.financeCostLedgers.length; i++) {
                    if (taskDetails.financeCostLedgers[i].checked === true) {
                        result.push(taskDetails.financeCostLedgers[i]);
                    }
                }
            }
            console.log("result", result);

            return result;
        });

        setFinLedgersList(() => {
            const result = [];
            if (taskDetails) {
                for (let i = 0; i < taskDetails.financeCostLedgers.length; i++) {
                    result.push(taskDetails.financeCostLedgers[i]);
                }
            }
            return result;
        });

    }, [taskDetails])

    useEffect(() => {
        console.log("linkedFinLedgers", linkedFinLedgers);
    }, [linkedFinLedgers])

    useEffect(() => {
        setCommentsList(comments.reverse());

    }, [comments])


    const handleSelectChange = (selectedOptions, { name }) => {
        if (name === "assigneeID") {
            setAddTaskForm(prev => ({ ...prev, selectedAssignId: selectedOptions }))
            setAddTaskForm(prev => ({ ...prev, [name]: selectedOptions.map(option => option.value) }))
        } else {
            setAddTaskForm(prev => ({ ...prev, selectedApproverId: selectedOptions }))
            setAddTaskForm(prev => ({ ...prev, [name]: selectedOptions.value }))
        }
    };

    const SaveSingleAdj = (adjData) => {
        if (adjData?._id) {
            updateAdjustmentToTask(addTaskForm.taskId, adjData?._id, {
                date: dayjs(adjData.date).format("DD-MM-YYYY"),
                addedLedgers: adjData.addedLedgers.map(({ _id, ...rest }) => rest),
                remarks: adjData.remarks
            }).then(res => {
                toast.success("Adjustment updated successfully.");

                getOneTask(addTaskForm.taskId).then(response => {
                    const taskData = response.data.bookClosureTask;
                    dispatch(setAdjustments(taskData.adjustments));
                }).catch(error => {
                    swal("Error", `Error: ${error.response?.data?.error}` || "Task not found!", 'error');
                });

            }).catch(error => {
                swal("Error", `Error: ${error.response?.data?.error}` || "Adjustment Update Failed!", 'error');
            })
        } else {
            AddAdjustmentToTask(addTaskForm.taskId, {
                date: dayjs(adjData.date).format("DD-MM-YYYY"),
                addedLedgers: adjData.addedLedgers,
                remarks: adjData.remarks
            }).then(res => {
                toast.success("Adjustment added successfully.");

                getOneTask(addTaskForm.taskId).then(response => {
                    const taskData = response.data.bookClosureTask;

                    dispatch(setAdjustments(taskData.adjustments));

                }).catch(error => {
                    swal("Error", `Error: ${error.response?.data?.error}` || "Task not found!", 'error');
                });

            }).catch(error => {
                swal("Error", `Error: ${error.response?.data?.error}` || "Adjustment Save Failed!", 'error');
            })
        }
    }

    const columnsData = () => {


        if (addedColumns && addedColumns.length > 0) {
            addedColumns.map((addedColumn, index) => {
                let columnObj = {
                    taskID: addTaskForm.taskId,
                    columnId: addedColumn.columnID,
                    columnTitle: addedColumn.columnTitle,
                    columnType: addedColumn.columnType,
                    columnValue: ""
                }
                if (taskDetails) {
                    const taskColumn = taskDetails?.columns.find(item => item.columnId === addedColumn.columnID)
                    if (taskColumn) {
                        columnObj["columnValue"] = taskColumn.columnValue
                    }
                }
                setTaskColumnList((prev) => [...prev, columnObj]);
            })
        }
    }


    useEffect(() => {
        setTaskColumnList([])
        columnsData();
    }, [taskDetails])

    useEffect(() => {
        addTaskForm.columns = taskColumnList
            .filter(item => item.columnValue?.toString().trim() !== "")
            .map(item => ({
                columnId: item.columnId,
                columnValue: item.columnValue
            }));

    }, [taskColumnList])

    const commentThreadHandler = (commentId) => {
        const selComment = commentsList.filter(comment => comment._id === commentId);
        setCommentText(selComment);
        setShowCommentThread(true);
    }

    const postCommentReply = (commentId, taskId) => {
        if (!taskId) {
            toast.warning("Please Save The Task.");
            return;
        }
        const payload = {
            taskID: taskId,
            commentID: commentId,
            replyText: commentReply,
        };
        postReplyApiHandler(payload)
            .then((response) => {
                ViewTaskMore(addTaskForm.taskId);
                // setCommentsList((response.data.comments).reverse());
                toast.success("Reply posted successfully.");
                setShowCommentThread(false);
            })
            .catch((error) => {
                swal(
                    "Error",
                    error?.response?.data?.error || "Unable post reply",
                    "error"
                );
            });
    }

    const [selectComment, setSelectComment] = useState(null); // ID of clicked column
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
    const thRefs = useRef({}); // refs for each <th>
    const hoverTimeout = useRef(null);


    const handleClick = (columnId) => {
        const rect = thRefs.current[columnId].getBoundingClientRect();
        setPopupPosition({
            top: rect.bottom + window.scrollY,
            left: rect.left + window.scrollX,
        });
        setSelectComment(columnId);
    };

    const handleMouseLeave = () => {
        hoverTimeout.current = setTimeout(() => {
            setSelectComment(null);
        }, 200);
    };

    const handlePopupEnter = () => {
        clearTimeout(hoverTimeout.current);
    };

    const deleteComment = (commentId) => {

        const payload = {
            taskID: addTaskForm.taskId,
            commentID: commentId,
        };
        deleteCommentApiHandler(payload)
            .then((response) => {
                ViewTaskMore(addTaskForm.taskId)
                // setCommentsList((response.data.comments).reverse());
                toast.success("Comment deleted successfully.");
                setShowCommentThread(false);
            })
            .catch((error) => {
                swal(
                    "Error",
                    error?.response?.data?.error || "Unable post reply",
                    "error"
                );
            });
    }

    const updateCommentStatus = (commentId, assignee, status) => {
        const payload = {
            taskID: addTaskForm.taskId,
            commentID: commentId,
            assignee: assignee,
            status: status
        };

        updateCommentApiHandler(payload)
            .then((response) => {
                // setCommentsList((response.data.comments).reverse());
                ViewTaskMore(addTaskForm.taskId)
                setShowCommentThread(false);
            })
            .catch((error) => {
                swal(
                    "Error",
                    error?.response?.data?.error || "Unable to update status",
                    "error"
                );
            });
    }

    const handleRegisterCheckboxChange = (index) => {
        const updatedList = [...registersList];
        updatedList[index].checked = !updatedList[index].checked;
        setRegistersList(updatedList);

    };

    const handleDepLedgerCheckboxChange = (index) => {
        const updatedList = [...depLedgersList];
        updatedList[index].checked = !updatedList[index].checked;
        setDepLedgersList(updatedList);

    };

    const handleFinLedgerCheckboxChange = (index) => {
        const updatedList = [...finLedgersList];
        updatedList[index].checked = !updatedList[index].checked;
        setFinLedgersList(updatedList);

    };

    useEffect(() => {
        if (taskDetails) {
            setDepreciationLedgerAmount(taskDetails?.depreciationLedgerValue)
            setFinanceLedgerAmount(taskDetails?.financeCostLedgerValue)
            getRegistersData();
        }
    }, [taskDetails, linkedRegisters])

    useEffect(() => {
        if (!showRegistersList) {
            const checkedRegs = registersList.filter((reg) => reg.checked);
            setLinkedRegisters(checkedRegs);
        }
    }, [showRegistersList, registersList])

    useEffect(() => {
        if (!showDepLedgersList) {
            const checkedLedgers = depLedgersList.filter((led) => led.checked);
            setLinkedDepLedgers(checkedLedgers);
        }
    }, [showDepLedgersList, depLedgersList])

    useEffect(() => {

        if (!showFinLedgersList) {
            const checkedLedgers = finLedgersList.filter((led) => led.checked);
            setLinkedFinLedgers(checkedLedgers);
        }
    }, [showFinLedgersList, finLedgersList])

    useEffect(() => {
        setDepreciationDifferenceAmount(depreciationRegisterAmount - depreciationLedgerAmount);
    }, [depreciationRegisterAmount, depreciationLedgerAmount])

    useEffect(() => {
        setFinanceDifferenceAmount(financeLedgerAmount - financeRegisterAmount);
    }, [financeLedgerAmount, financeRegisterAmount])

    // const updateLinkedRegisters = () => {
    //     const checkedRegs = registersList.filter((reg) => reg.checked);
    //     setLinkedRegisters(checkedRegs);
    // }
    const getRegistersData = () => {

        const checkedRegs = registersList.filter((reg) => reg.checked);
        const payload = {
            taskID: taskDetails?._id,
            registerIds: checkedRegs.map((reg) => reg.registerID)
        }

        getRegistersDataApiHandler(payload)
            .then((response) => {
                if (response.data.success) {
                    const get_params = { from: "01-04-2024", to: "30-01-2026" }
                    const leasePayload = {
                        leaseIDs: response.data.leaseIds
                    }
                    getAllLeaseDataApiHandler(get_params, leasePayload).then((resp) => {
                        if (resp.statusText === "OK") {
                            var leaseResponse = resp.data
                            setDepreciationRegisterAmount(leaseResponse.totalValue.accountingEntries.depreciationCharges.depreciationChargesDr);
                            setFinanceRegisterAmount(leaseResponse.totalValue.accountingEntries.interestCharge.interestDr);
                            setShowRegistersList(false);
                            if (leaseResponse.totalValue.accountingEntries.depreciationCharges.accumulatedDepreciation.length > 0) {
                                const totalAccumulatedDepreciation = leaseResponse.totalValue.accountingEntries.depreciationCharges.accumulatedDepreciation.reduce((sum, item) => sum + item.value, 0);
                                setTotalAccumulatedDepreciationAmount(totalAccumulatedDepreciation)
                            }

                        } else {
                            swal(
                                "Error",
                                "Error in getting lease data",
                                "error"
                            );

                        }
                    }).catch((error) => {
                        swal(
                            "Error",
                            error?.response?.data?.error || "Error in getting lease data",
                            "error"
                        );
                    });

                } else {
                    swal(
                        "Error",
                        response?.data?.error || "Error in Saving Registers",
                        "error"
                    );
                }

            })
            .catch((error) => {
                swal(
                    "Error",
                    error?.response?.data?.error || "Error in Saving Registers",
                    "error"
                );
            });

    }

    const getLedgersData = (type) => {
        var checkedDepLedgers = []
        if (type === "depreciation") {
            checkedDepLedgers = depLedgersList.map(({ _id, ...rest }) => rest);
        }
        if (type === "finance") {
            checkedDepLedgers = finLedgersList.map(({ _id, ...rest }) => rest);
        }
        const payload = {
            taskID: taskDetails?._id,
            type: type,
            ledgers: checkedDepLedgers
        }

        updateTemplateTaskLedgersApiHandler(payload)
            .then((response) => {
                if (response.data.success) {
                    if (type === "depreciation") {
                        setDepreciationLedgerAmount(response.data.data.depreciationLedgerValue);
                        setShowDepLedgersList(false);
                    }
                    if (type === "finance") {
                        setFinanceLedgerAmount(response.data.data.financeCostLedgerValue);
                        setShowFinLedgersList(false);
                    }
                } else {
                    swal(
                        "Error",
                        response?.data?.error || "Error in Saving Registers",
                        "error"
                    );
                }

            })
            .catch((error) => {
                swal(
                    "Error",
                    error?.response?.data?.error || "Error in Saving Registers",
                    "error"
                );
            });

    }


    const updateConnectedTaskReview = (isReviewed) => {
        const payload = {
            taskID: prevTaskId,
            reviewedTasks: [
                {
                    taskID: addTaskForm.taskId,
                    reviewed: isReviewed
                }
            ]
        };

        updateConnectedTaskReviewApiHandler(payload)
            .then((response) => {
                toast.success("Task marked as Reviewed");
            })
            .catch((error) => {
                swal(
                    "Error",
                    error?.response?.data?.error || "Unable to update status",
                    "error"
                );
            });
    }


    const reopenTaskHandler = () => {

        const params = { id: addTaskForm.taskId }

        reopenBookClosureTaskApiHandler(params)
            .then((response) => {
                if (response.data.success) {
                    toast.success("Task reopened successfully");
                    setReOpenTask(false);
                } else {
                    swal(
                        "Error",
                        "Unable to reopen task",
                        "error"
                    );
                }

            })
            .catch((error) => {
                swal(
                    "Error",
                    error?.response?.data?.error || "Unable to reopen task",
                    "error"
                );
            });
    }


    const reviewAllTasks = () => {
        console.log("connectedTasks", connectedTasks)
        const reviewedTaskObjects = connectedTasks.map(task => ({
            taskID: task._id,
            reviewed: true
        }));
        console.log("reviewedTaskObjects", reviewedTaskObjects)

        const payload = {
            taskID: addTaskForm.taskId,
            reviewedTasks: reviewedTaskObjects
        }

        updateConnectedTaskReviewApiHandler(payload)
            .then((response) => {
                if (response.data.success) {
                    toast.success("Tasks marked as Reviewed");
                } else {
                    swal(
                        "Error",
                        "Unable to update status",
                        "error"
                    );

                }
            })
            .catch((error) => {
                swal(
                    "Error",
                    error?.response?.data?.error || "Unable to update status",
                    "error"
                );
            });

    }
    return (
        <>
            {isLeaseMonthlyDepFinModal && (
                <Modal
                    title="Edit Template"
                    width="90%"
                    bodycss={commoncss.unsetPadding}
                    bodyStyle={{ "overflow": "hidden" }}
                    navigateBack=
                    {checkReviewed !== "N" ? (<LeftIcon className={`${commoncss.clickable} mr-2`} style={{ "vertical-align": "baseline" }} onClick={() => { ViewTaskMore(prevTaskId) }} />) : ""}
                    headerActions={
                        <>
                            <div className={commoncss.dFlex}>

                                {checkReviewed === "N" && (<ToggleButton
                                    label={"Confidential"}
                                    value={addTaskForm.isConfidential}
                                    onToggle={(e) => {
                                        setAddTaskForm((prev) => ({
                                            ...prev,
                                            isConfidential: e,
                                        }));
                                    }}
                                    class_={`${disableActions ? commoncss.noActions : ''}`}
                                />)}&ensp;

                                {checkReviewed !== "N" && (
                                    <>
                                        <button
                                            className={`${buttoncss.custom_btn} ${buttoncss.secondary}`}
                                            onClick={() => { updateConnectedTaskReview(true) }}
                                        >
                                            Reviewed
                                        </button>&ensp;
                                    </>
                                )}

                                {checkReviewed === "N" && reOpenTask && (
                                    <>
                                        <button
                                            className={`${buttoncss.custom_btn} ${buttoncss.secondary}`}
                                            onClick={() => { reopenTaskHandler() }}
                                        >
                                            Re-open Task
                                        </button>&ensp;
                                    </>
                                )}

                                <CloseIcon
                                    onClick={() => { handleTaskModalClose(); }}
                                    className="clickable"
                                />
                            </div>
                        </>
                    }
                    footerActions={
                        <>
                            <span></span>
                            <span>
                                <button
                                    onClick={SaveTask}
                                    variant="outlined"
                                    className={`${buttoncss.custom_btn} ${buttoncss.secondary}`}
                                >
                                    {userData?.responsibilities === "approver" ? "Return" : "Save"}
                                </button>
                                <button
                                    onClick={UpdateTask}
                                    variant="contained"
                                    className={`${buttoncss.custom_btn} ${buttoncss.primary} ml-3`}
                                >
                                    {userData?.responsibilities === "approver" ? "Approve" : "Submit"}
                                </button>
                            </span>
                        </>
                    }
                    onClose={() => console.log("Modal Closed")}
                >

                    <div class={`${commoncss.pdlr15} ${bookclosuretaskscss.taskContainer}`} style={{ "overflow": "hidden" }}>
                        <div
                            class={`${commoncss.pdlr15}  ${commoncss.m_tb_20} ${bookclosuretaskscss.taskContainerLeft}`}
                            style={{ "overflow": "auto", "height": "65vh" }}
                        >


                            <InputGroup

                                label="Task Name"
                                req={true}
                                inputs={[
                                    <>
                                        <input
                                            name="name"
                                            value={addTaskForm.name}
                                            className={`${disableActions ? commoncss.noActions : ''}`}
                                            onChange={(e) =>
                                                setAddTaskForm((prev) => ({
                                                    ...prev,
                                                    name: e.target.value,
                                                }))
                                            }
                                        />
                                    </>,
                                ]}
                            />


                            <InputGroup

                                label="Module Name"
                                req={true}
                                inputs={[
                                    <>
                                        <input
                                            name="module"
                                            value={addTaskForm.module}
                                            className={`${disableActions ? commoncss.noActions : ''}`}
                                            onChange={(e) =>
                                                setAddTaskForm((prev) => ({
                                                    ...prev,
                                                    module: e.target.value,
                                                }))
                                            }
                                        />
                                    </>,
                                ]}
                            />

                            <InputGroup
                                label="Task Description"
                                inputs={[
                                    <>
                                        <textarea

                                            rows={4}
                                            placeholder="Enter task description"
                                            name="description"
                                            className={`${disableActions ? commoncss.noActions : ''}`}
                                            value={addTaskForm.description}
                                            onChange={(e) =>
                                                setAddTaskForm((prev) => ({
                                                    ...prev,
                                                    description: e.target.value,
                                                }))
                                            }
                                        />
                                    </>,
                                ]}
                            />
                            <span className="input-label"><ReqFieldLabel />&nbsp;Assignee</span>
                            <Select
                                isMulti
                                placeholder="Assign..."
                                name="assigneeID"
                                value={addTaskForm.selectedAssignId}
                                onChange={handleSelectChange}
                                options={assignOptions}
                                className={`basic-multi-select w-100 mt-1 mb-2 custom-bg-gray-300 ${disableActions ? commoncss.noActions : ''}`}
                                classNamePrefix="select"
                                components={animatedComponents}
                                closeMenuOnSelect={false}
                                styles={customStyles}
                            />
                            <InputGroup
                                inputs={[
                                    <>
                                        {/* <Dropdown
                                                  label="Approver"
                                                  req={true}
                                                  options={approveOptions}
                                                  onSelect={(value) => { }}
                            
                                                  placeHolder={"Select Approver"}
                                                /> */}
                                        <span className="input-label"><ReqFieldLabel />&nbsp;Approver</span>
                                        <Select
                                            placeholder="Select Approver"
                                            name="approverID"
                                            value={addTaskForm.selectedApproverId}
                                            onChange={handleSelectChange}
                                            options={approveOptions}
                                            className={`w-100 mt-0 custom-bg-gray-300 ${disableActions ? commoncss.noActions : ''}`}
                                            classNamePrefix="select"
                                            components={animatedComponents}
                                            styles={customStyles}
                                        />

                                    </>,
                                    <>
                                        <InputGroup
                                            label="Due Date"
                                            req={true}
                                            inputs={[
                                                <>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                                                            <MobileDatePicker
                                                                className={`${commoncss.datePickerContainer} ${commoncss.clickable} ${disableActions ? commoncss.noActions : ''}`}
                                                                value={dayjs(addTaskForm.dueDate)}
                                                                onChange={(value) => {
                                                                    setAddTaskForm((prev) => ({
                                                                        ...prev,
                                                                        dueDate: value,
                                                                    }));
                                                                }}
                                                                format="DD-MMM-YYYY"
                                                                slotProps={{
                                                                    textField: {
                                                                        InputProps: {
                                                                            disableUnderline: true,
                                                                        },
                                                                        sx: {
                                                                            '& fieldset': {
                                                                                border: 'none',
                                                                            },
                                                                        },
                                                                    },
                                                                }}
                                                            />
                                                        </DemoContainer>
                                                    </LocalizationProvider>
                                                    <span className="icon">
                                                        <CalenderIcon
                                                            className="vaMiddle"
                                                            width={20}
                                                            height={20}
                                                        />
                                                    </span>
                                                </>,
                                            ]}
                                        />
                                    </>,
                                ]}
                            />
                            {taskColumnList && taskColumnList.length > 0 && (
                                <InputGroup
                                    inputs={taskColumnList.map((addedColumn, index) => (
                                        <InputGroup
                                            key={addedColumn.columnId}
                                            label={addedColumn.columnTitle}
                                            inputs={[
                                                addedColumn.columnType === "longText" ? (
                                                    <textarea
                                                        key={addedColumn.columnId}
                                                        className={`${disableActions ? commoncss.noActions : ''}`}
                                                        value={addedColumn?.columnValue || ""}
                                                        onChange={(e) => {
                                                            const updatedValue = e.target.value;
                                                            setTaskColumnList((prevList) =>
                                                                prevList.map((item, i) =>
                                                                    i === index ? { ...item, columnValue: updatedValue } : item
                                                                )
                                                            );
                                                        }}
                                                    />
                                                ) : (
                                                    <input
                                                        key={addedColumn.columnId}
                                                        className={`${disableActions ? commoncss.noActions : ''}`}
                                                        type={addedColumn.columnType === "date" ? "date" : "text"}
                                                        value={addedColumn?.columnValue || ""}
                                                        onChange={(e) => {
                                                            const updatedValue = e.target.value;
                                                            setTaskColumnList((prevList) =>
                                                                prevList.map((item, i) =>
                                                                    i === index ? { ...item, columnValue: updatedValue } : item
                                                                )
                                                            );
                                                        }}
                                                    />
                                                ),
                                            ]}
                                        />
                                    ))}
                                />
                            )}

                            <span className="input-label">Tag Linked Ledgers</span>
                            <Select
                                isMulti
                                placeholder="Select Ledgers"
                                name="linkedLedgers"
                                value={addTaskForm.linkedLedgers}
                                onChange={handleSelectChange}
                                options={tagLedgers}
                                getOptionLabel={(e) => e.ledgerName}
                                getOptionValue={(e) => e.ledgerCode}
                                className={`basic-multi-select w-100 mt-1 mb-2 custom-bg-gray-300 ${disableActions ? commoncss.noActions : ''}`}
                                classNamePrefix="select"
                                components={animatedComponents}
                                closeMenuOnSelect={false}
                                styles={customStyles}
                            />
                            <InputGroup
                                label="Comments"
                                inputs={[
                                    <>
                                        <span className={commoncss.imgIconInput}>
                                            <img className="vaMiddle" style={{ "borderRadius": "50%" }} width={37} height={37} src={User3} alt="user_image" />
                                            <input type="button" placeholder="Add Comment" onClick={setAddCommentModal} />
                                            <span className="icon">
                                                <RoundedCheckIcon
                                                    className="vaMiddle"
                                                    width={20}
                                                    height={20}
                                                />
                                            </span>
                                        </span>
                                    </>,
                                ]}
                            />

                            {commentsList && !showCommentThread && commentsList.length > 0 && (
                                commentsList.map((comment, index) => (
                                    <div className={`mt-1 mb-2 ${commentscss.commentsCard}`} key={index}>
                                        <div className={commoncss.flexCenter} style={{ "justify-content": "space-between" }}>
                                            <div>
                                                <img className="vaMiddle" style={{ "borderRadius": "50%" }} width={30} height={30} src={User3} alt="user_image" />
                                                <span className={`ml-2 ${commentscss.fs15}`} style={{ fontWeight: "600" }}>
                                                    {/* {comment.createdByData.name} */}
                                                    User
                                                </span>
                                                <span className={`ml-2 ${commentscss.greyLabel}`}>{dayjs(comment.updatedAt).format("MMM D YYYY hh:mm A")}</span>
                                            </div>
                                            <div>
                                                <span style={{ fontSize: "14px" }}>Assigned to</span>
                                                <img className="vaMiddle ml-1" style={{ "borderRadius": "50%" }} width={30} height={30} src={User3} alt="user_image" />
                                                <span className={`ml-1`} style={{ fontSize: "14px" }}>
                                                    {/* {comment.assigneeData.name} */}
                                                    Assignee
                                                </span>
                                                <span className={`ml-2`} style={{ fontSize: "14px" }}><CalenderIcon
                                                    className="vaMiddle"
                                                    width={20}
                                                    height={20}
                                                    style={{ "margin-top": "-3px" }}
                                                /> Due Date {dayjs(comment.dueDate).format("MMM D YYYY")}</span>
                                                <span
                                                    ref={(el) => (thRefs.current[comment._id] = el)}
                                                    onClick={() => handleClick(comment._id)}
                                                    onMouseLeave={handleMouseLeave}
                                                    style={{ cursor: "pointer" }}
                                                ><MenuDotIcon /></span>
                                            </div>
                                        </div>
                                        <hr className="mt-2 mb-2" />
                                        <div>
                                            <span className={commentscss.commentText}>
                                                {comment.text}
                                            </span>
                                            <div className="mt-2" style={{ "display": "flex", "justify-content": "flex-end" }}>
                                                <span></span>
                                                {/* <span> */}
                                                {comment.replies && comment.replies.length > 0 && (
                                                    <span className={commoncss.clickable} style={{ "width": "140px", "align-content": "space-around", "text-align": "center" }} onClick={() => { commentThreadHandler(comment._id) }}>
                                                        <span style={{ "color": "green" }}>●</span>&ensp;<span className={commoncss.labelBlack} style={{ fontSize: "13px" }}>{comment.replies.length} {comment.replies.length > 1 ? 'replies' : 'reply'}</span>
                                                    </span>
                                                )}
                                                {/* </span> */}
                                                <span style={{ "display": "flex", "justify-content": "space-between", "width": "325px" }}>

                                                    <button className={`${buttoncss.custom_btn}`} style={{ "border": "unset", "padding": "5px 10px", "min-width": "unset", "width": "130px" }} onClick={() => { commentThreadHandler(comment._id) }} >
                                                        <span className={commoncss.labelBlack} style={{ fontSize: "14.4px" }}><ReplyIcon /> Reply</span>
                                                    </button>
                                                    &ensp;
                                                    <Select
                                                        value={{ "label": comment.status, "value": comment.status }}
                                                        onChange={(e) => {
                                                            updateCommentStatus(comment._id, comment.assigneeData._id, e.value)

                                                        }}
                                                        options={commentStatuses}
                                                        className={`mt-0 custom-bg-gray-300 ${commoncss.w260}`}
                                                        classNamePrefix="select"
                                                        components={animatedComponents}
                                                        styles={
                                                            comment.status === "unresolved"
                                                                ? unresolvedCustomStyles
                                                                : comment.status === "overdue"
                                                                    ? overdueCustomStyles
                                                                    : closedCustomStyles
                                                        }
                                                    />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}

                            {selectComment && (
                                <div
                                    onMouseEnter={handlePopupEnter}
                                    onMouseLeave={handleMouseLeave}
                                    style={{
                                        position: "absolute",
                                        top: popupPosition.top,
                                        left: popupPosition.left,
                                        backgroundColor: "white",
                                        border: "1px solid #ccc",
                                        padding: "8px",
                                        borderRadius: "4px",
                                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                                        zIndex: 9999,
                                        minWidth: "120px",
                                    }}
                                >
                                    <div className={`${commoncss.fs15} p-1`}>Edit Comment</div>
                                    <div
                                        className={`${commoncss.clickable} ${commoncss.fs15} p-1`}
                                        onClick={() => {
                                            deleteComment(selectComment);
                                        }}
                                    >
                                        Delete Comment
                                    </div>
                                </div>
                            )}

                            {selComment && showCommentThread && selComment.length > 0 && (
                                selComment.map((comment, index) => (
                                    <div className={`mt-1 mb-2 ${commentscss.commentsCard}`} key={index}>
                                        <div className={commoncss.flexCenter} style={{ "justify-content": "space-between" }}>
                                            <div>
                                                <LeftIcon className={commoncss.clickable} height={15} width={15} onClick={() => { setShowCommentThread(false) }} />&ensp;Thread by
                                                <img className="vaMiddle ml-2" style={{ "borderRadius": "50%" }} width={30} height={30} src={User3} alt="user_image" />
                                                <span className={`ml-2 ${commentscss.fs15}`} style={{ fontWeight: "600" }}>
                                                    {/* {comment.createdByData.name} */}
                                                    User
                                                </span>
                                                {/* <span className={`ml-2 ${commentscss.greyLabel}`}>{dayjs(comment.updatedAt).format("MMM D YYYY hh:mm A")}</span> */}
                                            </div>
                                            <div>
                                                <Select
                                                    value={{ "label": comment.status, "value": comment.status }}
                                                    onChange={(e) => {
                                                        updateCommentStatus(comment._id, comment.assigneeData._id, e.value)
                                                    }}
                                                    options={commentStatuses}
                                                    className={`mt-0 custom-bg-gray-300 ${commoncss.w260}`}
                                                    classNamePrefix="select"
                                                    components={animatedComponents}
                                                    styles={
                                                        comment.status === "unresolved"
                                                            ? unresolvedCustomStyles
                                                            : comment.status === "overdue"
                                                                ? overdueCustomStyles
                                                                : closedCustomStyles
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <hr className="mt-2 mb-2" />
                                        <div>
                                            <div>
                                                <div className="mt-2">
                                                    <img className="vaMiddle" style={{ "borderRadius": "50%" }} width={30} height={30} src={User3} alt="user_image" />
                                                    <span className={`ml-2 ${commentscss.fs15}`} style={{ fontWeight: "600" }}>
                                                        {/* {comment.createdByData.name} */}
                                                        User
                                                    </span>
                                                    <span className={`ml-2 ${commentscss.greyLabel}`}>{dayjs(comment.updatedAt).format("MMM D YYYY hh:mm A")}</span>
                                                </div>
                                                <div className={`mt-2 p-2 ${commentscss.commentText}`}>
                                                    {comment.text}
                                                </div>
                                            </div>
                                            {comment.replies && comment.replies.length > 0 && (
                                                <div>
                                                    <div className={`${commoncss.flexCenter} m-3`}>
                                                        <span className={commoncss.primaryLableColor} style={{ "width": "100px", "font-size": "14px" }}>
                                                            {comment.replies.length} Replies
                                                        </span>
                                                        <span style={{ "width": "-webkit-fill-available" }}>
                                                            <hr className={`mt-2 mb-2 ${commoncss.hr2}`} />
                                                        </span>
                                                    </div>
                                                    {comment.replies.map((reply, index) => (
                                                        <div className="px-3 mb-4">
                                                            <div className="mt-2">
                                                                <img className="vaMiddle" style={{ "borderRadius": "50%" }} width={30} height={30} src={User3} alt="user_image" />
                                                                <span className={`ml-2 ${commentscss.fs15}`} style={{ fontWeight: "600" }}>
                                                                    {/* {reply.name} */}
                                                                    User
                                                                </span>
                                                                <span className={`ml-2 ${commentscss.greyLabel}`}>{dayjs(reply.updatedAt).format("MMM D YYYY hh:mm A")}</span>
                                                            </div>
                                                            <div className={`mt-2 p-2 ${commentscss.commentText}`}>
                                                                {reply.text}
                                                            </div>
                                                        </div>
                                                    ))}

                                                </div>
                                            )}
                                            <div className="px-3 mb-4">
                                                <InputGroup
                                                    inputs={[
                                                        <>
                                                            <span className={commoncss.imgIconInput}>
                                                                <input type="text" placeholder="Type a reply" onChange={(e) => { setCommentReply(e.target.value) }} />
                                                                <span className={`icon ${commoncss.clickable}`} style={{ "pointer-events": "unset" }} onClick={() => { postCommentReply(comment._id, addTaskForm.taskId) }} >
                                                                    <RoundedCheckIcon
                                                                        className="vaMiddle"
                                                                        width={20}
                                                                        height={20}
                                                                    />
                                                                </span>
                                                            </span>
                                                        </>,
                                                    ]}
                                                />
                                            </div>

                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                        <div
                            class={`${commoncss.pdlr15} ${commoncss.m_tb_20} ${bookclosuretaskscss.taskContainerRight}`}
                            style={{ "overflow": "auto", "height": "65vh" }}
                        >
                            <div>
                                <span className={commoncss.primaryLabel1}>Linked Registers</span>

                                <div className="d-flex mt-2 flex-wrap" style={{ gap: "15px" }}
                                >
                                    {linkedRegisters.map((reg, idx) => (
                                        <>
                                            <span className={`${commoncss.tag1}`}>{reg.name}</span>
                                        </>
                                    ))}
                                    <span><EditIcon className={commoncss.clickable} width={20} onClick={() => { setShowRegistersList(!showRegistersList) }} /></span>
                                </div>
                                {showRegistersList && (
                                    <div className={`${commoncss.itemsDiv} mt-4`}
                                    >
                                        <div className={commoncss.dFlexJustifysb}>
                                            <span className={commoncss.primaryLabel1}>Select Registers</span>
                                            <span>
                                                <Button
                                                    class_={buttoncss.subBtn}
                                                    btnColor={buttoncss.primary}
                                                    label="Save"
                                                    onClick={() => { getRegistersData() }}
                                                />
                                            </span>
                                        </div>

                                        <div className="mt-3  d-flex flex-wrap">
                                            {registersList.map((reg, idx) => (
                                                <>
                                                    <span className="d-flex align-items-center mr-4 mb-2"><input type="checkbox" id={reg.registerID} checked={reg.checked} onChange={() => handleRegisterCheckboxChange(idx)} className={commoncss.m0} /><span className={`ml-2 mr-4 ${commoncss.label3} ${commoncss.vaTextBottom}`}>{reg.name}</span></span>
                                                </>
                                            ))}
                                        </div>
                                    </div>
                                )}

                            </div>
                            {/* <div name="exist" className={`${commoncss.itemsDiv} clickable `}
                            >
                            </div> */}
                            <div className="mt-3">
                                <span className={commoncss.labelBlack}>Depreciation</span>
                                <div className={commoncss.greyDiv}>
                                    <div className={commoncss.flexSB}><span className={commoncss.label3}>As per register</span><span className={commoncss.labelBlk3}>{formatAmount(depreciationRegisterAmount)}</span></div>
                                    <div className={`${commoncss.flexSB} mt-3`}><span className={commoncss.label3}>As per Ledgers</span><span className={commoncss.labelBlk3}>{formatAmount(depreciationLedgerAmount)}</span></div>
                                    <div className={`${commoncss.flexSB} mt-4`}><span className={commoncss.label3}>Difference</span><span className={commoncss.labelBlk3}>{formatAmount(depreciationDifferenceAmount)}</span></div>

                                    <div className={`mt-4`}>
                                        <span className={commoncss.primaryLabel1}>Linked Ledgers</span>

                                        <div className="d-flex mt-2 flex-wrap" style={{ gap: "15px" }}
                                        >
                                            {linkedDepLedgers.map((ledger, idx) => (
                                                <>
                                                    <span className={`${commoncss.tag2}`}>{ledger.ledgerName}</span>
                                                </>
                                            ))}
                                            <span><EditIcon className={commoncss.clickable} width={15} onClick={() => { setShowDepLedgersList(!showDepLedgersList) }} /></span>
                                        </div>
                                        {showDepLedgersList && (
                                            <div className={`${commoncss.itemsDiv} mt-4`}
                                            >
                                                <div className={commoncss.dFlexJustifysb}>
                                                    <span className={commoncss.primaryLabel1}>Select Ledgers</span>
                                                    <span>
                                                        <Button
                                                            class_={buttoncss.subBtn}
                                                            btnColor={buttoncss.primary}
                                                            label="Save"
                                                            onClick={() => { getLedgersData("depreciation") }}
                                                        />
                                                    </span>
                                                </div>

                                                <div className="mt-3  d-flex flex-wrap">
                                                    {depLedgersList.map((ledger, idx) => (
                                                        <>
                                                            <span className="d-flex align-items-center mr-4 mb-2"><input type="checkbox" id={ledger._id} checked={ledger.checked} onChange={() => handleDepLedgerCheckboxChange(idx)} className={commoncss.m0} /><span className={`ml-2 mr-4 ${commoncss.label3} ${commoncss.vaTextBottom}`}>{ledger.ledgerName}</span></span>
                                                        </>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>


                            <div className="mt-3">
                                <span className={commoncss.labelBlack}>Finance</span>
                                <div className={commoncss.greyDiv}>
                                    <div className={commoncss.flexSB}><span className={commoncss.label3}>As per register</span><span className={commoncss.labelBlk3}>{formatAmount(financeRegisterAmount)}</span></div>
                                    <div className={`${commoncss.flexSB} mt-3`}><span className={commoncss.label3}>As per Ledgers</span><span className={commoncss.labelBlk3}>{formatAmount(financeLedgerAmount)}</span></div>
                                    <div className={`${commoncss.flexSB} mt-4`}><span className={commoncss.label3}>Difference</span><span className={commoncss.labelBlk3}>{formatAmount(financeDifferenceAmount)}</span></div>
                                    <div className={`mt-4`}>
                                        <span className={commoncss.primaryLabel1}>Linked Ledgers</span>

                                        <div className="d-flex mt-2 flex-wrap" style={{ gap: "15px" }}
                                        >
                                            {linkedFinLedgers.map((ledger, idx) => (
                                                <>
                                                    <span className={`${commoncss.tag2}`}>{ledger.ledgerName}</span>
                                                </>
                                            ))}
                                            <span><EditIcon className={commoncss.clickable} width={15} onClick={() => { setShowFinLedgersList(!showFinLedgersList) }} /></span>
                                        </div>
                                        {showFinLedgersList && (
                                            <div className={`${commoncss.itemsDiv} mt-4`}
                                            >
                                                <div className={commoncss.dFlexJustifysb}>
                                                    <span className={commoncss.primaryLabel1}>Select Ledgers</span>
                                                    <span>
                                                        <Button
                                                            class_={buttoncss.subBtn}
                                                            btnColor={buttoncss.primary}
                                                            label="Save"
                                                            onClick={() => { getLedgersData("finance") }}
                                                        />
                                                    </span>
                                                </div>

                                                <div className="mt-3  d-flex flex-wrap">
                                                    {finLedgersList.map((ledger, idx) => (
                                                        <>
                                                            <span className="d-flex align-items-center mr-4 mb-2"><input type="checkbox" id={ledger._id} checked={ledger.checked} onChange={() => handleFinLedgerCheckboxChange(idx)} className={commoncss.m0} /><span className={`ml-2 mr-4 ${commoncss.label3} ${commoncss.vaTextBottom}`}>{ledger.ledgerName}</span></span>
                                                        </>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>

                            <div className="mt-3">
                                <span className={commoncss.labelBlack}>Suggested Entries</span>
                                <div className={`${bookclosuretablecss.bookClosureTableContainer}`} style={{ "width": "100%", "border-radius": "10px" }}>
                                    <table className={`${bookclosuretablecss.bookClosureTable} ${bookclosuretablecss.bookclosureEntries}`}>
                                        <thead style={{ backgroundColor: "#E5E7E9", "border": "1px solid #eaeeed" }}>
                                            <tr>
                                                <th className="text-left text-uppercase font-size-14 custom-font-600">Category</th>
                                                <th className="text-left text-uppercase font-size-14 custom-font-600">References</th>
                                                <th className="text-left text-uppercase font-size-14 custom-font-600">Account (DR)</th>
                                                <th className="text-right text-uppercase font-size-14 custom-font-600">Account (CR)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-left" rowSpan={2}>Depreciation</td>
                                                <td className="text-left">Depreciation</td>
                                                <td className="text-left">
                                                    {depreciationRegisterAmount < 0 ? formatAmount(Math.abs(depreciationRegisterAmount)) : 0}
                                                </td>
                                                <td className="text-left">
                                                    {depreciationRegisterAmount >= 0 ? formatAmount(depreciationRegisterAmount) : 0}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-left">Accumulated Depreciation</td>
                                                <td className="text-left">
                                                    {totalAccumulatedDepreciationAmount < 0 ? formatAmount(Math.abs(totalAccumulatedDepreciationAmount)) : 0}
                                                </td>
                                                <td className="text-left">
                                                    {totalAccumulatedDepreciationAmount >= 0 ? formatAmount(totalAccumulatedDepreciationAmount) : 0}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                            <br/>
                            <InputGroup
                                label="Workings & Remarks"
                                // icon={<AttachmentIcon className={commoncss.vaMiddle} width={18} />}
                                // iconLabel="Attach files"
                                inputs={[
                                    <>
                                        <textarea
                                            value={addTaskForm?.workingsAndRemarks || ""}
                                            placeholder="Type Something..."
                                            onChange={(e) => {
                                                setAddTaskForm((prev) => ({
                                                    ...prev,
                                                    workingsAndRemarks: e.target.value,
                                                }));
                                            }}
                                            rows={10}
                                            className={disableActions ? commoncss.noActions : ''}
                                        />
                                    </>,
                                ]}
                            />
                            <div className={`${tablecss.tableContainer}`}>
                                <table className={`${tablecss.customTable} ${tablecss.taskTable} ${tablecss.adjCustomTable}`}>
                                    <thead>
                                        <tr>
                                            <th >
                                                Date
                                            </th>
                                            <th >
                                                Ledger Code
                                            </th>
                                            <th >
                                                Ledger Name
                                            </th>
                                            <th >
                                                Amount
                                            </th>
                                            <th >
                                                Remarks
                                            </th>
                                            <th >Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className={disableActions ? commoncss.noActions : ''}>
                                        {adjustments?.length > 0 &&
                                            adjustments.map((adjustment, ax) => (
                                                <React.Fragment key={ax}>
                                                    {adjustment?.addedLedgers?.length > 0 &&
                                                        adjustment.addedLedgers.map((ledger, lx) => (
                                                            <tr key={lx}>
                                                                {lx === 0 && (
                                                                    <td className={`{text-left  ${disableActions ? commoncss.noActions : ''}}`} rowSpan={adjustment?.addedLedgers.length}>
                                                                        <>
                                                                            <div className="input-group-wrapper">
                                                                                <div className="input-group">
                                                                                    <div className={`input-col`} style={{ "width": "150px" }}>
                                                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                            <DemoContainer components={["MobileDatePicker"]}>
                                                                                                <MobileDatePicker
                                                                                                    slotProps={{
                                                                                                        textField: {
                                                                                                            name: "date",
                                                                                                            className: `${commoncss.adjDatePickerContainer}`,
                                                                                                            style: { "width": "100px !important" },
                                                                                                            placeholder: "Select date",
                                                                                                            InputProps: {
                                                                                                                disableUnderline: true,
                                                                                                            },
                                                                                                            inputProps: {
                                                                                                                placeholder: "Select date",
                                                                                                            },
                                                                                                            sx: {
                                                                                                                '& fieldset': {
                                                                                                                    border: 'none',
                                                                                                                },
                                                                                                            },
                                                                                                        },
                                                                                                    }}
                                                                                                    value={adjustment?.date ? dayjs(adjustment.date) : null}
                                                                                                    onChange={(value) => {
                                                                                                        // mimic native input's target structure
                                                                                                        const adjDateEvent = { target: { name: "date", value: value?.format("YYYY-MM-DD") } };
                                                                                                        dispatch(setOnchangeAdj(ax, null, adjDateEvent.target, adjustments, ledgers));
                                                                                                    }}
                                                                                                    format="DD-MMM-YYYY" // same format as native input[type="date"]
                                                                                                />
                                                                                            </DemoContainer>
                                                                                        </LocalizationProvider>

                                                                                        <span className="icon">
                                                                                            <CalenderIcon
                                                                                                className="vaMiddle"
                                                                                                width={20}
                                                                                                height={20}
                                                                                            />
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        {/* <input
                                                                                type="date"
                                                                                // value={dayjs(adjustment?.date).format("YYYY-MM-DD")}
                                                                                value={adjustment?.date}
                                                                                name="date"
                                                                                onChange={(e) => {
                                                                                  dispatch(setOnchangeAdj(ax, null, e.target, adjustments, ledgers));
                                                                                }}
                                                                                className="form-control"
                                                                              /> */}
                                                                    </td>
                                                                )}

                                                                <td className="text-left">
                                                                    <InputGroup
                                                                        inputs={[
                                                                            <>
                                                                                {/* <select
                                                                                    value={ledger?.ledgerCode}
                                                                                    name="ledgerCode"
                                                                                    onChange={(e) => {
                                                                                      dispatch(setOnchangeAdj(ax, lx, e.target, adjustments, ledgers))
                                                                                    }}
                                                                                    className={`form-control ${commoncss.customDropdown}`}
                                                                                    style={{ "width": "110px" }}
                                                                                  >
                                                                                    <option value="" disabled selected>
                                                                                      Select Ledger Code
                                                                                    </option>
                                                                                    <option value={ledger?.ledgerCode}>
                                                                                      {ledger?.ledgerCode}
                                                                                    </option>
                                                                                    {ledgers.map((ledgerOption, idx) => (
                                                                                      <option key={idx} value={ledgerOption.ledgerCode}>
                                                                                        {ledgerOption.ledgerCode}
                                                                                      </option>
                                                                                    ))}
                                                                                  </select> */}
                                                                                <Select
                                                                                    className="w-100 mt-0 custom-bg-gray-300"
                                                                                    classNamePrefix="select"
                                                                                    components={animatedComponents}
                                                                                    styles={{
                                                                                        ...customStyles,
                                                                                        container: (provided) => ({
                                                                                            ...provided,
                                                                                            width: 'fit-content',  // or 'auto'
                                                                                            minWidth: '110px',     // optional: keep a minimum width if needed
                                                                                        }),
                                                                                    }}
                                                                                    menuPortalTarget={document.body}
                                                                                    name="ledgerCode"
                                                                                    value={{
                                                                                        value: ledger.ledgerCode,
                                                                                        label: ledger.ledgerCode
                                                                                    }
                                                                                    }

                                                                                    onChange={(selectedOption) => {
                                                                                        const syntheticEvent = {
                                                                                            name: 'ledgerCode',
                                                                                            value: selectedOption?.value,
                                                                                        };
                                                                                        dispatch(setOnchangeAdj(ax, lx, syntheticEvent, adjustments, ledgers));
                                                                                    }}
                                                                                    options={[
                                                                                        // Include current ledger code if it exists and is not already in the list
                                                                                        ...(ledger?.ledgerCode &&
                                                                                            !ledgers.some((l) => l.ledgerCode === ledger.ledgerCode)
                                                                                            ? [{ value: ledger.ledgerCode, label: ledger.ledgerCode }]
                                                                                            : []),
                                                                                        // Map all other ledger options
                                                                                        ...ledgers.map((l) => ({
                                                                                            value: l.ledgerCode,
                                                                                            label: l.ledgerCode,
                                                                                        })),
                                                                                    ]}
                                                                                    placeholder="Select Ledger Code"
                                                                                    isSearchable
                                                                                />
                                                                            </>,
                                                                        ]}
                                                                    />

                                                                </td>
                                                                <td className="text-left">

                                                                    <InputGroup
                                                                        inputs={[
                                                                            <>
                                                                                <input
                                                                                    type="text"
                                                                                    name="ledgerName"
                                                                                    value={ledger?.ledgerName}
                                                                                    onChange={(e) => {
                                                                                        dispatch(setOnchangeAdj(ax, lx, e.target, adjustments, ledgers))
                                                                                    }}
                                                                                    disabled
                                                                                />
                                                                            </>,
                                                                        ]}
                                                                    />


                                                                </td>
                                                                <td className="text-left">
                                                                    <div className={commoncss.flexCenter}>
                                                                        <InputGroup
                                                                            inputs={[
                                                                                <>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={ledger?.adjustmentAmount}
                                                                                        name="adjustmentAmount"
                                                                                        onChange={(e) => {
                                                                                            dispatch(setOnchangeAdj(ax, lx, e.target, adjustments, ledgers))
                                                                                        }}
                                                                                        className="form-control"
                                                                                    />
                                                                                </>,
                                                                            ]}
                                                                        />&ensp;&ensp;
                                                                        <DeleteRedIcon onClick={() => dispatch(removeAdjustmentFromTable(ax, lx, adjustments))} />
                                                                    </div>
                                                                </td>
                                                                {lx === 0 && (
                                                                    <>

                                                                        <td className="text-left" rowSpan={adjustment?.addedLedgers.length}>
                                                                            <InputGroup
                                                                                inputs={[
                                                                                    <>
                                                                                        <textarea
                                                                                            value={adjustment?.remarks}
                                                                                            name="remarks"
                                                                                            onChange={(e) => {
                                                                                                dispatch(setOnchangeAdj(ax, null, e.target, adjustments, ledgers));
                                                                                            }}
                                                                                        />
                                                                                    </>,
                                                                                ]}
                                                                            />

                                                                        </td>
                                                                        <td rowSpan={adjustment?.addedLedgers.length}>
                                                                            <div className={commoncss.flexCenter}>
                                                                                <button
                                                                                    onClick={() => SaveSingleAdj(adjustment)}
                                                                                    className="primary-border px-2 py-1 bg-white rounded custom-common-theme-text-color"
                                                                                >
                                                                                    {adjustment?._id ? "Update" : "Save"}
                                                                                </button>
                                                                            </div>
                                                                        </td>
                                                                    </>
                                                                )}
                                                            </tr>
                                                        ))}
                                                </React.Fragment>
                                            ))}
                                        <tr>
                                            <td scope="row" colSpan={6}>
                                                <TableButton
                                                    btnColor={buttoncss.secondary}
                                                    label="Add Adjustment"
                                                    icon={<PrimaryPlusIcon />}
                                                    onClick={() => {
                                                        dispatch(setNewAdjustmentToTable(adjustments));
                                                    }}
                                                />

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <br />
                            {checkReviewed === "N" && (
                                <div>
                                    <div className={commoncss.dFlexJustifysb}>
                                        <label className={commoncss.primaryLableColor}>Connected Tasks</label>
                                        {connectedTasks.length > 0 && (
                                            <Button
                                                class_="mb-2"
                                                btnColor={`${buttoncss.secondary} ${buttoncss.subBtn}`}
                                                icon={<RoundedCheckIcon width={20} />}
                                                label="Reviewed All"
                                                onClick={() => { reviewAllTasks() }}
                                            />
                                        )}
                                    </div>
                                    <BookClosureConnectedTasks ViewTaskMore={ViewTaskMore} connectedTasks={connectedTasks} parentTaskId={addTaskForm.taskId} />
                                </div>
                            )}
                        </div>
                    </div>
                </Modal>
            )
            }

            {/* <AddLedgerToTaskModal AddLedgerToTask={AddLedgerToTask} />
                  <EditLedgerTaskModal
                    UpdateLedgerInTask={() =>
                      UpdateLedgerInTask(
                        ledgerDetails.ledgerId,
                        ledgerDetails.remark,
                        ledgerDetails.amount
                      )
                    }
                    ledgerDetails={ledgerDetails}
                    setLedgerDetails={setLedgerDetails}
                  /> */}

            {addCommentModal && (
                <AddCommentModal
                    setAddCommentModal={setAddCommentModal}
                    taskId={addTaskForm.taskId}
                    assignOptions={assignOptions}
                    setCommentsList={setCommentsList}
                // setCreateColumnFieldModal={setCreateColumnFieldModal}
                // setColumnTitle={setColumnTitle}
                // addBookClosureColumns={addBookClosureColumns}
                />
            )}
        </>
    );
};

export default LeaseModal;
